import axios from '@/axios';
import kitchensUrl from '@/apis/kitchens'

export default {
    fetchAll(nested) {
        if (nested === undefined) nested = true;
        return axios.get(`${kitchensUrl}/locations?nested=${nested}`);
    },
}